import React, { useEffect } from 'react';
import CategoryCard from 'src/components/homepage/CategoryCard';
import { useTranslation } from 'react-i18next';
import { KatSpinner, KatAlert } from '@amzn/katal-react';
import FetchStatus from 'src/types/FetchStatus';
import { useAppSelector, useAppDispatch } from 'src/redux/hooks';
import { AppState } from 'src/redux/store';
import { fetchCategories } from 'src/redux/slices/threadCategories';
import { isStatusLoading } from 'src/utils';

const DiscussionCategory = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const categories = useAppSelector((state: AppState) => state.threadCategories.categories);
  const categoriesStatus = useAppSelector((state: AppState) => state.threadCategories.status);

  const categoryList = Object.values(categories);
  useEffect(() => {
    if (categoriesStatus !== FetchStatus.complete) dispatch(fetchCategories());
  }, []);

  if (isStatusLoading(categoriesStatus)) return <KatSpinner data-testid="discussion-category-spinner" size="small" />;
  if (categoriesStatus === FetchStatus.failed) {
    return (
      <KatAlert
        data-testid="discussion-category-alert"
        persistent
        className="my-6"
        variant="warning"
        description={t('request_homePageCategoriesFetchFailureDescription')}
        header={t('request_homePageCategoriesFetchFailureHeader')}
      />
    );
  }

  const getCategoryCards = () => categoryList.map(({
    nameStringId,
    id: categoryId,
  }) => (
    /**
       * @todo To fetch discussion count and last activity time
       * sim - https://sim.amazon.com/issues/SPCE-3275
       */
    <CategoryCard
      key={categoryId}
      categoryId={categoryId}
      nameStringId={nameStringId}
    />
  ));

  return (
    <div
      data-testid="discussion-categories"
      className="mt-3.5 mb-[26px] border border-solid border-y-kat-seattle border-x-transparent bg-kat-azure pt-[22px] pb-6.5"
    >
      <div className="container">
        <div className="kat-col-lg-8 kat-offset-lg-2">
          <h3 className="mb-3.5">{t('homePage_categoryHeader')}</h3>
          <div className="grid grid-cols-1 gap-x-4.5 gap-y-2 sm:grid-cols-2">
            {getCategoryCards()}
          </div>

        </div>
      </div>
    </div>
  );
};

export default DiscussionCategory;
